<template>
  <div class="home">
    <h1>Podcasts</h1>
    <section v-if="errored">
      <p>We're sorry, we're not able to retrieve this information at the moment,
        please try back later</p>
    </section>

    <section v-else class="podcast">
      <div v-for="podcast in podcasts"
        :key="podcast.id"
        class="item">
        <router-link :to="{ name: 'Podcast', params: { id: podcast.id }}">
          <img width="250" height="250" :src="podcast.artworkUrl">
          <div class="title">
              {{ podcast.title }}
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PodcastsList',
  data() {
    return {
      podcasts: null,
      loading: true,
      errored: false,
    };
  },
  filters: {
    currencydecimal(value) {
      return value.toFixed(2);
    },
  },
  mounted() {
    axios
      .get('api/podcasts')
      .then((response) => {
        this.podcasts = response.data;
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>

  a {
    font-weight: bold;
    color: #2c3e50;
  }
.podcast {
  display: flex;
  flex-wrap: wrap;
  /*align-content: flex-start;*/
  justify-content: space-evenly;
}
.item {
  flex-shrink: 1;
  flex-grow: 0;
  flex-basis: 30%;
  margin: 10px;
  padding: 5px;
  /*height: 100px;*/
  /*background-color: blue;*/
}
  .title {
    font-size: 20px;
  }
</style>
